<template>
  <!-- category list -->
  <div class="vx-card p-2">
    <div class="vx-row mb-6">
      <!--  name -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType === 'client'">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" v-model="form.business_name" label=" Name" name=" Name" />
      </div>

      <!-- First name -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType !== 'client'">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" v-model="form.first_name" label="First Name" name=" Name" />
      </div>

      <!--  last name -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType !== 'client'">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" v-model="form.last_name" label=" Last Name" name=" last_name" />
      </div>

      <!--  Address -->
      <div class="vx-col w-full lg:w-1/2">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" label="Address" v-model="form.address" name="Address" />
      </div>

      <!-- License Number -->
      <div class="vx-col w-full lg:w-1/2">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" label="License Number" name="License Number" v-model="form.license_number" />
      </div>

      <!-- Email Address -->
      <div class="vx-col w-full lg:w-1/2">
        <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" label="Email Address" v-model="form.email" name="Email Address" />
      </div>

      <!-- Phone Number -->
      <div class="vx-col w-full lg:w-1/2">
        <vs-input icon="icon icon-package" type="number" icon-pack="feather" class="w-full" label=" Phone Number" v-model="form.phone" name=" Phone Number" />
      </div>

      <!-- Discount Type -->
      <div class="vx-col w-full lg:w-1/2">
        <label>Discount Type</label>
        <select-2
          autocomplete
          class="w-full"
          v-model="form.taxDiscountId"
          @input="(item) => (form.taxDiscountId = item && item.value)"
          label-placeholder="Discount Type"
          name="Discount Type"
          placeholder="Select Discount Type"
          :options="systemDiscountTypeOptions"
        />
      </div>

      <!-- License Expiry Date -->
      <div class="vx-col w-full lg:w-1/2">
        <label>License Expiry Date</label>
        <date-picker :appendToBody="false" v-model="form.license_expiry_date" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" valueType="format" class="w-full" />
      </div>
      <!-- Date of Birth -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType !== 'client'">
        <label for="">Date of Birth</label>
        <date-picker :appendToBody="false" v-model="form.dob" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" valueType="format" class="w-full" />
      </div>

      <!--  role -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType === 'client'">
        <label>Role </label>
        <select-2
          autocomplete
          class="w-full"
          :value="form.role"
          @input="(item) => (form.role = item && item.value)"
          label-placeholder="Role"
          name="Role"
          placeholder="Select Role"
          :options="roleOptions"
        />
      </div>

      <!-- patient type -->
      <div class="vx-col w-full lg:w-1/2" v-show="customerType !== 'client'">
        <label>Patient Type </label>
        <select-2
          autocomplete
          class="w-full"
          name="Patient Type"
          @input="(item) => (form.patient_type = item && item.value)"
          placeholder="Select Patient Type"
          :options="patientOptions"
          :value="form.patient_type"
        />
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row text-center">
      <div class="vx-col w-full px-4">
        <div class="items-center">
          <vs-button button="submit" class="ml-2 text-left" type="relief" @click="save_changes">Save</vs-button>
        </div>
      </div>
    </div>

    <hr class="mt-3 mb-5" />
    <!-- invoice product details -->
    <div>
      <customerLastPOS :lastRecord="customerLastPOSRecord" />
    </div>
  </div>
</template>

<script>
import customerLastPOS from '@/views/pos/components/POS/CustomerLastPOS.vue'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import moment from 'moment'
import { clientRoleOptions, patientTypes } from '@/utils/enums'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'CustomerDetails',

  components: {
    customerLastPOS,
    Select2,
    DatePicker
  },

  props: {
    customer: Number
  },

  data() {
    return {
      customerType: null,
      dateFormat: 'MM-DD-YYYY',
      form: {
        business_name: '',
        first_name: '',
        last_name: '',
        license_number: '',
        address: '',
        phone: '',
        license_expiry_date: null,
        dob: null,
        taxDiscountId: '',
        email: '',
        role: null,
        patient_type: null
      },
      roleOptions: clientRoleOptions,
      patientOptions: patientTypes
    }
  },

  computed: {
    ...mapState('pos', ['loading', 'customerLastPOSRecord', 'customers']),
    ...mapState('setting', ['loading', 'systemDiscountAndTax']),

    validateForm() {
      return !this.errors.any()
    },

    // system discount type options
    systemDiscountTypeOptions() {
      return this.systemDiscountAndTax.reduce((acc, item) => {
        acc.push({
          label: item.name,
          value: item.id
        })

        return acc
      }, [])
    }
  },

  methods: {
    handleCustomerData() {
      const customerData = this.customers.find((x) => x.id === this.customer)
      this.customerType = customerData.customer_type
      this.form.business_name = customerData.business_name
      this.form.first_name = customerData.first_name
      this.form.last_name = customerData.last_name
      this.form.license_number = customerData.license_number
      this.form.address = customerData.address
      this.form.phone = customerData.phone
      this.form.license_expiry_date = moment(customerData.license_expiry_date).format('MM-DD-YYYY') || null
      this.form.taxDiscountId = customerData.taxDiscountId
      this.form.email = customerData.email
      this.form.role = customerData.role
      this.form.dob = moment(customerData.dob).format('MM-DD-YYYY') || null
      this.form.patient_type = customerData.patient_type
    },

    async save_changes() {
      this.$store
        .dispatch(this.customerType === 'client' ? 'client/update' : 'patient/update', {
          id: this.customer,
          data: {
            ...this.form,
            dob: this.form.dob ? moment(this.form.dob).format('YYYY-MM-DD') : null,
            license_expiry_date: this.form.license_expiry_date ? moment(this.form.license_expiry_date).format('YYYY-MM-DD') : null
          }
        })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: this.customerType === 'client' ? 'Client updated successfully!' : 'Patient updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$router.go()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    customerLastPOSRecord: {
      handler() {
        this.handleCustomerData()
      }
    }
  }
}
</script>
<style lang="scss">
.vdp-datepicker__calendar {
  width: 100% !important;
}
.clear_icon {
  z-index: 300;
}
</style>

